import { createSelector } from '@reduxjs/toolkit';

import { TBrandCar } from '@/selectors/getBrandCar';
import { config, WidgetMode } from '@/utils';

import getVehicles from './getVehicles';
import getCarDiscounts from './getCarDiscounts';
import getCarTradeIn from './getCarTradeIn';
import { State } from '../apps/appCreator/store';

const minCreditCalcPrice = config.get('minCreditCalcPrice') || 0;

const isDealerMode = WidgetMode.isDealerMode();

/**
 * Параметры, необходимые для инициализации виджета "Кредитный калькулятор"
 */
const getCreditCalcOpts = createSelector(
  getVehicles,
  getCarDiscounts,
  getCarTradeIn,
  (state: State, car: TBrandCar | undefined) => car,
  ({ vehicles }, carDiscounts, tradeIn, car) => {
    if (!car || !vehicles) return undefined;

    const { model, extra } = car;

    const vehicle = vehicles.find(item => item.id === model.toLowerCase());
    const modification = vehicle?.modifications[0];

    if (!modification) {
      return undefined;
    }

    const { grades } = modification;

    /**
     * берем первую версию,
     * т.к. цену определяем с поля car.extra(price - (medicalDiscount + resolvedTradeInDiscount + dealerDiscount));
     */
    const version = `${grades[0].id}/${grades[0].versions[0].id}`;
    const resolvedDiscountPrice = [
      'medicalDiscount',
      'resolvedTradeInDiscount',
      'dealerDiscount',
    ].reduce((acc, discountName) => {
      const value = carDiscounts[discountName].selected
        ? carDiscounts[discountName].value
        : 0;

      return acc + value;
    }, 0);

    const price = (isDealerMode ? extra.dealerPrice : extra.price) - resolvedDiscountPrice;

    // устанавливаем минимальную стоимость авто (чтобы всегда отображать кредитные программы)
    const resolvedPrice =
      price < minCreditCalcPrice ? minCreditCalcPrice : price;

    // первоначальный взнос
    const initialPayment = tradeIn.initialPayment
      ? { initialPayment: { value: carDiscounts.tradeInPrice.value } }
      : {};

    return {
      version: {
        value: version,
        name: 'version',
      },
      modification: {
        value: modification?.id,
        name: 'modification',
      },
      price: {
        value: resolvedPrice,
      },
      period: {
        value: 12,
        name: 'period',
      },
      ...initialPayment,
    };
  }
);

export default getCreditCalcOpts;
